import { NavLink } from "react-router-dom";
import BrandMark from "./BrandMark";
import UserMenu from "./UserMenu";
import { NAV_ITEMS } from "../constants/navigation";
import { useAuth } from "../context/AuthContext";

const NAV_LINK_CLASS_BASE =
  "text-sm font-['DM_Sans'] font-medium pb-1 border-b-2 border-transparent transition-colors duration-150 ease-out";

const TopBar = () => {
  const { user } = useAuth();

  return (
    <header className="border-b border-gray-200/70">
      <div className="flex h-16 items-center justify-between gap-4">
        <BrandMark />

        {user && (
          <nav
            aria-label="Navegação principal"
            className="hidden md:flex items-center gap-6"
          >
            {NAV_ITEMS.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `${NAV_LINK_CLASS_BASE} ${
                    isActive
                      ? "text-[#1a202c] border-[#468BFF]"
                      : "text-gray-500 hover:text-[#1a202c]"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        )}

        {user && <UserMenu />}
      </div>
    </header>
  );
};

export default TopBar;
